import { Component, OnInit, Input } from '@angular/core';
import { IJobScreen } from '../../interfaces/job/job';
import { IOrganisationTag } from '../../interfaces/organisation-tag';
import { JobsService } from '../../services';

@Component({
  selector: 'tagging-requirements-details',
  templateUrl: 'tagging-requirements-details.component.html',
  styleUrls: ['tagging-requirements-details.component.css'],
})
export class TaggingRequirementsDetailsComponent implements OnInit {
  constructor(private jobService: JobsService) {}

  @Input('jobNumber') jobNumber: string;
  @Input('requiredTags') requiredTags: any[];
  @Input('supplierTags') supplierTags: any[];

  jobInfo: IJobScreen;

  ngOnInit() {
    //if (this.supplierTags.length > 0)
    //    console.log("Required tags: ", this.requiredTags, "  - supplier tags: ", this.supplierTags);
  }

  getTagClass(requiredTag: IOrganisationTag): string {
    // if the supplier tags don't contain the specified required tag, use the red class
    // NOT tags use the opposite check to other sets
    if (
      (requiredTag.tagSet > 0 &&
        this.supplierTags.findIndex((x) => x.tagEntity.name == requiredTag.tagEntity.name) >= 0) ||
      (requiredTag.tagSet == 0 &&
        this.supplierTags.findIndex((x) => x.tagEntity.name == requiredTag.tagEntity.name) < 0)
    ) {
      return 'tag-blue';
    } else {
      return 'tag-red';
    }
  }
}
